import {TeaserArticlesAction, TeaserArticlesState} from './types';
import {TEASER_ARTICLES_GET_INVALIDATE, TEASER_ARTICLES_GET_REQUEST, TEASER_ARTICLES_GET_RESPONSE} from '../actionTypes';

const initialState: TeaserArticlesState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'teaserArticles' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const teaserArticlesReducer = (
  state = initialState,
  action: TeaserArticlesAction,
): TeaserArticlesState => {
  switch (action.type) {
    case TEASER_ARTICLES_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
      };
    case TEASER_ARTICLES_GET_RESPONSE:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case TEASER_ARTICLES_GET_INVALIDATE:
      return {
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default teaserArticlesReducer;
